import { Injectable, signal } from '@angular/core';

export interface HeaderAction {
	label: string;
	icon: string;
	callback: () => void;
	variant?: 'primary' | 'secondary' | 'danger';
	disabled?: boolean;
}

export interface HeaderConfig {
	actions?: HeaderAction[];
	backButton?: {
		show: boolean;
		callback: () => void;
	};
}

@Injectable({
	providedIn: 'root',
})
export class AdminHeader {
	headerAction = signal<HeaderAction | null>(null);
	headerConfig = signal<HeaderConfig>({});

	setHeaderAction(action: HeaderAction | null) {
		this.headerAction.set(action);
	}

	setHeaderConfig(config: HeaderConfig) {
		this.headerConfig.set(config);
	}

	clearHeaderAction() {
		this.headerAction.set(null);
	}

	clearHeaderConfig() {
		this.headerConfig.set({});
	}
}
